import React, { useEffect } from 'react';
import { Route, RouteProps, useHistory } from 'react-router-dom';

interface ProtectedRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

/**
 * Componente para proteger rutas que requieren autenticación.
 * Verifica si existe un token válido en localStorage antes de permitir el acceso.
 * Si no hay token, redirige al usuario a la página de login.
 * También previene el acceso mediante el botón "atrás" después de cerrar sesión.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component, ...rest }) => {
  const history = useHistory();

  useEffect(() => {
    // Verificar autenticación al montar el componente
    const checkAuth = () => {
      const token = localStorage.getItem('token');
      if (!token) {
        // No hay token, redirigir al login
        history.replace('/admin/login');
      }
    };

    checkAuth();

    // Prevenir navegación hacia atrás después de logout
    const handlePopState = () => {
      const token = localStorage.getItem('token');
      if (!token) {
        history.replace('/admin/login');
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [history]);

  return (
    <Route
      {...rest}
      render={(props) => {
        const token = localStorage.getItem('token');
        if (!token) {
          return null; // O un componente de carga mientras redirige
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;

